<template>
  <a v-if="opensInNewTab" :href="anchorHref" target="_blank" rel="noopener noreferrer" v-bind="$attrs">
    <slot />
  </a>
  <InertiaLink v-else :href="transformedHref" v-bind="$attrs">
    <slot />
  </InertiaLink>
</template>

<script>
import { Link as InertiaLink, usePage } from '@inertiajs/vue3'
import { withSitePrefix } from '@/js/composables/useLangPath.js'

export default {
  name: 'NtLink',
  inheritAttrs: false,
  components: { InertiaLink },
  props: {
    href: {
      type: [String, Object],
      required: true
    },
    // Forces an internal path to open in a new tab as well. An Inertia visit
    // has nowhere to put a new tab — it swaps the current page — so opting in
    // switches the link to a plain anchor, keeping the site prefix on the href.
    newWindow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    external() {
      // Only treat root-relative paths (e.g. `/about-us`) as internal —
      // anything else (full https URLs, `tel:`, `mailto:`, fragments
      // owned by an external CMS, etc.) is external and skips Inertia +
      // the lang prefix.
      if (typeof this.href !== 'string') return false
      return !this.href.startsWith('/')
    },
    // External links have always opened in a new tab; `newWindow` extends that
    // to internal ones on request.
    opensInNewTab() {
      return this.external || this.newWindow
    },
    // An external href is passed through untouched; an internal one forced into
    // a new tab still needs the language/site prefix Inertia would have applied.
    anchorHref() {
      return this.external ? this.href : this.transformedHref
    },
    transformedHref() {
      if (typeof this.href !== 'string') {
        return this.href
      }
      return withSitePrefix(this.href, usePage().props)
    }
  }
}
</script>
